import React, { Component } from "react";
import { Table } from "antd";
import "./ResultsTable.css";

class ResultsTable extends Component {
		
	render() {
		// create an array of filter values for each type of data
		const renderDataFilters = filterType => {
			// for each search result, create filter objects containing the data's value
			let createFilterObjs = this.props.searchResults.map((dataItem, index) => {
				let filterDataObj = {
					text: dataItem[filterType],
					value: dataItem[filterType]
				};
				return filterDataObj;
			});
			// remove repeat values
			let uniqueArr = createFilterObjs.reduce((unique, o) => {
				if (
					!unique.some(obj => obj.label === o.label && obj.value === o.value)
				) {
					unique.push(o);
				}
				return unique;
			}, []);
			// do not render a filter if there is only one unique value for
			// each row's column in the table
			if (uniqueArr.length === 1) {
				return [];
			} else {
				return uniqueArr;
			}
		};
		
		
		// create columns
		// static values for custom filtering and sorting
		const columns = [
			{
				title: "NAME",
				dataIndex: "name",
				key: "name",
				width: 150,
				filters: renderDataFilters("name"),
				// specify the condition of filtering result
				// here is that finding the name started with `value`
				onFilter: (value, record) => record.name.indexOf(value) === 0,
				sorter: (a, b) => a.name.localeCompare(b.name)
			},
			{
				title: "SCORE",
				dataIndex: "score",
				key: "score",
				width: 100,
				filters: renderDataFilters("score"),
				onFilter: (value, record) => record.score.indexOf(value) === 0,
				sorter: (a, b) => a.score - b.score

			},
			{
				title: "TICKER",
				dataIndex: "ticker",
				key: "ticker",
				width: 100,
				filters: renderDataFilters("ticker"),
				onFilter: (value, record) => record.ticker.indexOf(value) === 0,
				//sorter: (a, b) =>{if (a.ticker > b.ticker) { return -1; } if (a.ticker < b.ticker) { return 1; } return 0;}, 
				sorter: (a, b) =>{var x= a.ticker; if (x==="--") {x="zzzz:ZZZZ";} var y=b.ticker; if (y==="--") {y="zzzz:ZZZZ";} if (x > y) { return -1; } if (x < y) { return 1; } return 0;},
				//compareByAlpha(a.ticker, b.ticker), 
				//a.ticker.localeCompare(b.ticker)
			},
			{
				title: "CATEGORY",
				dataIndex: "category",
				key: "category",
				width: 150,
				filters: renderDataFilters("category"),
				onFilter: (value, record) => record.category.indexOf(value) === 0,
				//sorter: (a, b) =>{if (a.category > b.category) { return -1; } if (a.category < b.category) { return 1; } return 0;}
				sorter: (a, b) =>{var x= a.category; if (x==="--") {x="ZZZZ";} var y=b.category; if (y==="--") {y="ZZZZ";} if (x > y) { return -1; } if (x < y) { return 1; } return 0;},
				//sorter: (a, b) => a.category.localeCompare(b.category)
			},
			{
				title: "COUNTRY",
				dataIndex: "country",
				key: "country",
				width: 100,
				filters: renderDataFilters("country"),
				onFilter: (value, record) => record.country.indexOf(value) === 0,
				//sorter: (a, b) =>{if (a.country > b.country) { return -1; } if (a.country < b.country) { return 1; } return 0;}, 
				sorter: (a, b) =>{var x= a.country; if (x==="--") {x="ZZZZ";} var y=b.country; if (y==="--") {y="ZZZZ";} if (x > y) { return -1; } if (x < y) { return 1; } return 0;},
				//sorter: (a, b) => a.country.localeCompare(b.country)
			},
//			{
//				title: "SIZE",
//				dataIndex: "size",
//				key: "size",
//				width: 100,
//				filters: renderDataFilters("size"),
//				onFilter: (value, record) => record.size.indexOf(value) === 0,
//				sorter: (a, b) =>{var x= a.size; if (x==="--") {x="ZZZ";} var y=b.size; if (y==="--") {y="ZZZ";} if (x > y) { return -1; } if (x < y) { return 1; } return 0;},
//			},
			{
				title: "M&A EXPERIENCE",
				dataIndex: "acquisition_experience",
				key: "acquisition_experience",
				width: 150,
				filters: renderDataFilters("acquisition_experience"),
				onFilter: (value, record) => record.acquisition_experience.indexOf(value) === 0,
				sorter: (a, b) =>{var x= a.acquisition_experience; if (x==="--") {x="ZZZ";} if (x==="VERY STRONG") {x="AAA";} if (x==="STRONG") {x="BBB";} if (x==="AVERAGE") {x="CCC";} if (x==="WEAK") {x="DDD";} 
				                  var y= b.acquisition_experience; if (y==="--") {y="ZZZ";} if (y==="VERY STRONG") {y="AAA";} if (y==="STRONG") {y="BBB";} if (y==="AVERAGE") {y="CCC";} if (y==="WEAK") {y="DDD";}
				                  if (x > y) { return -1; } if (x < y) { return 1; } return 0;},
			},
			
			{
				title: "MARKET CAP (M)",
				dataIndex: "mc",
				key: "mc",
				width: 150,
				filters: renderDataFilters("mc"),
				onFilter: (value, record) => record.mc.indexOf(value) === 0,
				sorter: (a, b) =>{var x= a.mc.replace(",","").replace("$",""); if (x==="--") {x=0;} var y=b.mc.replace(",","").replace("$",""); if (y==="--") {y=0;} return x-y;}, 
				//sorter: (a, b) => a.mc.length - b.mc.length
			},
			{
				title: "CASH & ST INVEST. (M)",
				dataIndex: "cashandshortinvest",
				key: "cashandshortinvest",
				width: 150,
				filters: renderDataFilters("cashandshortinvest"),
				onFilter: (value, record) => record.cashandshortinvest.indexOf(value) === 0,
				sorter: (a, b) =>{var x= a.cashandshortinvest.replace(",","").replace("$",""); if (x==="--") {x=0;} var y=b.cashandshortinvest.replace(",","").replace("$",""); if (y==="--") {y=0;} return x-y;}, 
				//sorter: (a, b) => a.cashandshortinvest - b.cashandshortinvest
			},
			{
				title: "GROSS MARGIN",
				dataIndex: "grossmargin",
				key: "grossmargin",
				width: 100,
				filters: renderDataFilters("grossmargin"),
				onFilter: (value, record) => record.grossmargin.indexOf(value) === 0,
				sorter: (a, b) =>{var x= a.grossmargin.replace(",","").replace("%",""); if (x==="--") {x=0;} var y=b.grossmargin.replace(",","").replace("%",""); if (y==="--") {y=0;} return x-y;}, 
				//sorter: (a, b) => a.grossmargin - b.grossmargin
			},

			{
				title: "DETAILS",
				dataIndex: "details",
				width: 150,
				key: "details"
			}
		];
		// renders billions with comma
		const renderBillionsMc = (x) => {
			return '$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
		
		// renders billions with comma
		const renderName = (x, y) => {
			return <span title={y}> {x} </span>;
		}
		// render data from search
		// placeholder in case of missing values
		const dataSource = this.props.searchResults.map((dataItem, index) => {
			//console.log("click "+index);
			return {
				key: dataItem.cik,
				name: renderName(dataItem.name, dataItem.description),
				//name: dataItem.name,
				score: dataItem.score,
				ticker: dataItem.exchange_ticker === "" ? "--" : dataItem.exchange_ticker,
				category: dataItem.category === "" ? "--" : dataItem.category,
				country: dataItem.country === "" ? "--" : dataItem.country,
				//size: dataItem.size === "" ? "--" : dataItem.size,
				acquisition_experience: dataItem.acquisition_experience === "" ? "--" : dataItem.acquisition_experience,
				mc: dataItem.mc === "" ? "--" : renderBillionsMc(dataItem.mc),
				grossmargin: dataItem.grossmargin === "" ? "--" : dataItem.grossmargin,
				cashandshortinvest: dataItem.cashandshortinvest === "" ? "--" : renderBillionsMc(dataItem.cashandshortinvest),
				details: (
					<p className="view-more-results-link"
						onClick={() =>
							this.props.changeLocation2(`/dashboard/company/${index}`, 'newWindow')}
					>
						View More
					</p>
				)
			};
		});

		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
				this.props.selectDataToExport(selectedRows);
			}
		};

		return (
			<Table
				columns={columns}
				dataSource={dataSource}
				pagination={{ pageSize: 10 }}
				scroll={{ y: 1500 }}
				rowSelection={rowSelection}
			/>
		);
	}
}

export default ResultsTable;


// WEBPACK FOOTER //
// ./src/components/SearchResults/ResultsTable/ResultsTable.js